/*eslint-disable*/
import dayjs from "dayjs";
import { isRequiredRule } from "../../../../helpers/validators";
import { removeEmptyProperties } from "../../../../helpers/general"
import i18next from "i18next";

const limitRegex = /^([4-9]\d|\d{3}|200)$/;

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const isValidEmailRule = (value) => {
  if (value && !emailRegex.test(value)) {
    return { isValid: false };
  }
  return { isValid: true };
};

const limitValidator = (filters, errorMsgs) => {
    const { limit } = filters;
    const numLimit = parseInt(limit, 10)
    if (numLimit && !limitRegex.test(numLimit))
      errorMsgs.limit = i18next.t('user-activities-filter-limit-validation');
  };

  const guidValidator = (filters, errorMsgs) => {
    const { guid } = filters;
    if (guid && guid.length>50)
      errorMsgs.guid = "Max allowed 50 characters";
  };

  const useridValidator = (filters, errorMsgs) => {
    const { userid } = filters;
    if (userid && userid.length>40)
      errorMsgs.userid = "Max allowed 40 characters";
  };

const endDateValidator = (filters, errorMsgs) => {
  const { startTime, endTime } = filters;
  const isEndTimeBeforeStartTime = dayjs(endTime).isBefore(dayjs(startTime));
  if (isEndTimeBeforeStartTime)
    errorMsgs.endTime = i18next.t('user-activities-filter-end-date-validation');
};

const emailFormatValidator = (filters, errorMsgs) => {
    const { isValid } = isValidEmailRule(filters.email);
    if (isValid) errorMsgs.email = "";
    else errorMsgs.email = "Invalid Email.";
  };

const emailRequiredValidator = (filters, errorMsgs) => {
  const { isValid } = isRequiredRule(filters.email);
  if (!isValid) errorMsgs.email = "Email is required.";
};

const emailValidator = (filters, errorMsgs) => {
    emailFormatValidator(filters, errorMsgs);
    //emailRequiredValidator(filters, errorMsgs);
  };

export const validateFilters = (filters) => {
  const errorMsgs = {};
  endDateValidator(filters, errorMsgs);
  emailValidator(filters, errorMsgs);
  limitValidator(filters, errorMsgs);
  guidValidator(filters, errorMsgs);
  useridValidator(filters, errorMsgs);
  return errorMsgs;
};

export const isMandatoryFieldSelected  = (filters) => {
  const selectedFilters = {...filters};
  delete selectedFilters.startTime;
  delete selectedFilters.endTime;
  delete selectedFilters.limit;
  return Object.keys(removeEmptyProperties(selectedFilters)).length > 0;
}
